import { GeneralPermissions } from "../../types/Permissions/GeneralPermissions";
import { NONE, type PermissionsInfo } from "./PermissionsInfo";

export const GeneralPermissionInfo: Record<GeneralPermissions, PermissionsInfo> = {
    [GeneralPermissions.None]: NONE,

    [GeneralPermissions.EditRoles]: {
        name: "Edit Roles",
        description: "Create, delete, and edit roles.",
    },

    [GeneralPermissions.EditTokens]: {
        name: "Edit Tokens",
        description: "Create, delete, and edit plugin authorisation tokens.",
    },

    [GeneralPermissions.EditEconomyRewards]: {
        name: "Edit Economy Rewards",
        description: "Create, delete, and edit economy rewards.",
    },
};
